import script from "./DRecordTime.vue?vue&type=script&setup=true&lang=js"
export * from "./DRecordTime.vue?vue&type=script&setup=true&lang=js"

import "./DRecordTime.vue?vue&type=style&index=0&id=18663f77&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18663f77"]])

export default __exports__